import State from './State';
import Action, { exeCenter, exeMoveRuler, exeMoveRulerLabel, exePan, exeRotate, exeSetActive, exeSetSize, exeSetState, exeZoom , exeConfigure } from './Action';
import { useReducer } from 'react';
import { exeResetTweaks } from './Action/ResetTweaks';

export type Emitter = ( a : Action ) => void;
export type Reducer = ( s : null | State , a : Action ) => null | State;

export interface UseTweaker {
	emit : Emitter;
	state : null | State;
}

export const reducer = ( s : null | State , a : Action ) : null | State => {

	if ( a.tag == 'SetState' )
		return exeSetState( a );

	if ( s == null )
		return s;

	switch ( a.tag ) {
	case 'Pan' : return exePan( s , a );
	case 'Zoom' : return exeZoom( s , a );
	case 'Rotate' : return exeRotate( s , a );
	case 'Center' : return exeCenter( s , a );
	case 'SetSize' : return exeSetSize( s , a );
	case 'Configure' : return exeConfigure( s , a );
	case 'SetActive' : return exeSetActive( s , a );
	case 'MoveRuler' : return exeMoveRuler( s , a );
	case 'ResetTweaks' : return exeResetTweaks( s , a );
	case 'MoveRulerLabel' : return exeMoveRulerLabel( s , a );
	}
};

export const useTweaker = ( i : null | State ) : UseTweaker => {
	const [ state , emit ] = useReducer< Reducer, null | State >( reducer , i , x => x );
	return { emit , state };
};
